export default {"src":"/pro/_next/static/media/gala.8eae92cd.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};